import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de tipos de servicio de alimentación
 * Migrado a Python FastAPI - Usa pythonApiClient
 * Maneja todas las operaciones CRUD relacionadas con tipos de servicio de alimentación
 */
export const tipoServicioAlimentacionApi = {
  /**
   * Obtiene todos los tipos de servicio de alimentación activos
   * @returns {Promise} - Respuesta de la API
   */
  getAll: () => {
    return pythonApiClient.get('/mantenimientos/tipos-servicios-alimentacion/');
  },

  /**
   * Obtiene un tipo de servicio de alimentación por ID
   * @param {number} id - ID del tipo de servicio de alimentación
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    return pythonApiClient.get(`/mantenimientos/tipos-servicios-alimentacion/${id}`);
  },

  /**
   * Crea un nuevo tipo de servicio de alimentación
   * @param {Object} data - Datos del tipo de servicio de alimentación
   * @param {string} data.descripcion - Descripción del tipo de servicio (obligatorio)
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    return pythonApiClient.post('/mantenimientos/tipos-servicios-alimentacion/', data);
  },

  /**
   * Actualiza un tipo de servicio de alimentación existente
   * @param {number} id - ID del tipo de servicio de alimentación
   * @param {Object} data - Datos actualizados del tipo de servicio
   * @param {string} [data.descripcion] - Descripción del tipo de servicio (opcional)
   * @param {boolean} [data.activo] - Estado activo/inactivo (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    return pythonApiClient.put(`/mantenimientos/tipos-servicios-alimentacion/${id}`, data);
  },

  /**
   * Elimina un tipo de servicio de alimentación (soft delete)
   * @param {number} id - ID del tipo de servicio de alimentación
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    return pythonApiClient.delete(`/mantenimientos/tipos-servicios-alimentacion/${id}`);
  },

  /**
   * Busca tipos de servicio de alimentación por término
   * @param {string} searchTerm - Término de búsqueda
   * @returns {Promise} - Respuesta de la API
   */
  search: (searchTerm) => {
    return pythonApiClient.get(`/mantenimientos/tipos-servicios-alimentacion/search/${searchTerm}`);
  },

  /**
   * Usos del tipo de servicio por proyecto (turnos, config, offline, menús, etc.)
   * @param {number} id
   */
  getUsos: (id) => {
    return pythonApiClient.get(`/mantenimientos/tipos-servicios-alimentacion/${id}/usos`);
  },

  /**
   * Unifica un tipo origen dentro de un tipo destino (mantiene destino).
   * @param {{ id_origen: number, id_destino: number }} data
   */
  unificar: (data) => {
    return pythonApiClient.post('/mantenimientos/tipos-servicios-alimentacion/unificar', data);
  },
};

export default tipoServicioAlimentacionApi;
